import React from 'react';
import { QStack } from '@qualio/ui-components';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import CheckBox from '../CheckBox';
import useUpdateEffect from '../../../hooks/useUpdateEffect';

export type QualityEventsPermissionsFormFields = {
  canViewQE: boolean;
  canCreateQE: boolean;
  canEditQE: boolean;
  canManageQE: boolean;
};

const QualityEventsPermissions = () => {
  const { values, setFieldValue } = useFormikContext<QualityEventsPermissionsFormFields>();
  const { canViewQE } = values;
  const checkboxesDisabled = !canViewQE;
  const { t } = useTranslation();

  useUpdateEffect(() => {
    if (!canViewQE) {
      setFieldValue('canCreateQE', false);
      setFieldValue('canEditQE', false);
      setFieldValue('canManageQE', false);
    }
  }, [canViewQE]);

  return (
    <QStack direction={['column']}>
      <CheckBox
        data-cy="permission-checkbox"
        name="canViewQE"
        label="can view quality events"
        text={t('forms.permissions.viewEvents')}
      />
      <QStack direction={['column']} paddingLeft="2rem" paddingRight="2rem">
        <CheckBox
          data-cy="permission-checkbox"
          name="canCreateQE"
          label="can create quality events"
          text={t('forms.permissions.createEvents')}
          isDisabled={checkboxesDisabled}
        />
        <CheckBox
          data-cy="permission-checkbox"
          name="canEditQE"
          label="can edit quality events"
          text={t('forms.permissions.editEvents')}
          isDisabled={checkboxesDisabled}
        />
        <CheckBox
          data-cy="permission-checkbox"
          name="canManageQE"
          label="can manage quality events"
          text={t('forms.permissions.manageEvents')}
          isDisabled={checkboxesDisabled}
        />
      </QStack>
    </QStack>
  );
};

export default QualityEventsPermissions;
